import router from '@/router'
import store from '@/store'
// import { Message } from 'element-ui'
import { message } from '@/utils/resetMessage'
export function handlerHttpError (res) {
  switch (res.code) {
    case 50002: // token失效
      if (res.message) {
        message.error(res.message)
      }
      localStorage.clear()
      router.push('/login')
      break
    default:
      if (res.message) {
        message.error(res.message)
      }
      break
  }
}



// WEBPACK FOOTER //
// ./src/utils/error.js